import React, { useEffect, useState, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { timezome } from '../../utils/constants';
import { SIGNAGE_MEDIA } from '../../utils/constants';
import API from '../../utils/API';

const Clock = ({
  setSuccess,
  closeModal,
  refreshData,
  data = [],
  clockData = {},
  zone = "",
  setZone,
  setZoneData,
  updatePlaylistsMedia,
  markUnsavedChanges
}) => {

  const [modalError, setModalError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [clockType, setClockType] = useState(SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_ANALOG);
  const [timeFormat, setTimeFormat] = useState(1);
  const [timezone, setTimezone] = useState('Pacific/Pago_Pago');

  const clockTypeOptions = [
    { value: SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_ANALOG, label: <FormattedMessage id="ANALOG" /> },
    { value: SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_DIGITAL, label: <FormattedMessage id="DIGITAL" /> }
  ];
  const timeFormatOptions = [
    { value: 1, label: <FormattedMessage id="12_HOUR" /> },
    { value: 0, label: <FormattedMessage id="24_HOUR" /> }
  ];
  const timezoneOptions = Object.entries(timezome).map(([value, label]) => ({
    value,
    label
  }));

  useEffect(() => {
    if (Object.keys(data).length > 0 && data.id) {
      const clockParameters = data.content.paramters;
      setClockType(clockParameters.type || SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_ANALOG);
      setTimeFormat(clockParameters.format ?? 1);
      setTimezone(clockParameters.timeZone || 'Pacific/Pago_Pago');
    }
  }, [data]);

  useEffect(() => {
     if (zone !== SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1&&zone !== SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET2) return;
    if (clockData && clockData.content && clockData.content.paramters) {
      const clockParameters = clockData.content.paramters;
      setClockType(clockParameters.type || SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_ANALOG);
      setTimeFormat(clockParameters.format || 1);
      setTimezone(clockParameters.timeZone || 'Pacific/Pago_Pago');
    }
  }, [clockData, zone]);

  useEffect(() => {
    if (clockType === SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_ANALOG) {
      setTimeFormat(1);
    }
  }, [clockType]);

  /**
    * Reset modal
    */
  function resetModal() {
    setSubmitted(false);
    setModalError('');
    if (setZone)
      setZone('');
  }

  useEffect(() => {
    const modalElement = document.getElementById('clockModal');
    modalElement.addEventListener('hidden.bs.modal', resetModal);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', resetModal);
    };
  }, []);

  const handleAdd = async () => {
    try {
      if (zone) {
        setZoneData(prevClockData => {
          const newClockData = { ...prevClockData };
          newClockData[zone] = {
            zone: zone,
            content: {
              category: SIGNAGE_MEDIA.MEDIA_CATEGORY.WIDGET,
              subcategory: SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CLOCK,
              type: SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CLOCK,
              name: SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CLOCK,
              paramters: {
                type: clockType,
                format: timeFormat,
                timeZone: timezone
              }
            }
          };
          return newClockData;
        });
      } else {
        const formData = {
          category: SIGNAGE_MEDIA.MEDIA_CATEGORY.WIDGET,
          subcategory: SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CLOCK,
          type: SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CLOCK,
          name: SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CLOCK,
          content: {
            paramters: {
              type: clockType,
              format: timeFormat,
              timeZone: timezone
            }
          }
        };
        if (Object.keys(data).length > 0 && data.id) {
          formData.id = data.id;
          await API.updateMedia(formData);
          updatePlaylistsMedia(formData);
          setSuccess(<FormattedMessage id="EDIT_CLOCK_SUCCESS" />);
        } else {
          await API.addMedia(formData);
          setSuccess(<FormattedMessage id="ADD_CLOCK_SUCCESS" />);
        }
        markUnsavedChanges && markUnsavedChanges();
        refreshData();
      }
      closeModal("clockModal");
    } catch (err) {
      const errorId = Object.keys(data).length > 0 && data.id ? "EDIT_CLOCK_FAILED" : "ADD_CLOCK_FAILED";
      setModalError(<FormattedMessage id={errorId} values={{ errorMsg: <b>{err.message}</b> }} />);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    handleAdd();
  };

  return (
    <div className='modal modal-mse fade' id='clockModal' tabIndex='-1' aria-labelledby='clockModalLabel' aria-hidden='true'>
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content modal-mes-content' style={{ overflow: 'visible' }}>
          <div className='modal-header modal-mes-header' style={{ backgroundColor: '#347BFA' }}>
            <h5 className='modal-title modal-mes-title'><FormattedMessage id='CLOCK' /></h5>
            <button id="closeModal" type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
          </div>
          <div className='modal-body'>
            <form onSubmit={handleSubmit}>
              <div className='row'>
                <div className="mb-3">
                  <label className="font-weight-600 font-size-14 mb-2"><FormattedMessage id="SELECT_CLOCK_TYPE" />:</label>
                  <select
                    className="form-select h-54"
                    value={clockType}
                    onChange={(e) => setClockType(e.target.value)}
                    style={{
                      backgroundColor: 'rgba(248, 249, 252, 1)',
                      borderColor: '#ced4da',
                      color: 'rgba(149, 149, 151, 1)',
                    }}
                  >
                    {clockTypeOptions.map((option) => (
                      <option key={option.value} value={option.value}  style={{ color: '#000' }}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="mb-3">
                  <label className="font-weight-600 font-size-14 mb-2"><FormattedMessage id="TIME_FORMAT" defaultMessage="Time Format" />:</label>
                  <select
                    className="form-select h-54 clock-type-select"
                    disabled={clockType === SIGNAGE_MEDIA.MEDIA_TYPE.TYPE_ANALOG}
                    value={timeFormat}
                    onChange={(e) => setTimeFormat(Number(e.target.value))}
                    style={{
                      backgroundColor: 'rgba(248, 249, 252, 1)',
                      borderColor: '#ced4da',
                      color: 'rgba(149, 149, 151, 1)',
                    }}
                  >
                    {timeFormatOptions.map((option) => (
                      <option key={option.value} value={option.value} style={{ color: '#000' }}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="mb-3">
                  <label className="font-weight-600 font-size-14 mb-2"><FormattedMessage id="TIMEZONE" defaultMessage="Timezone" />:</label>
                  <select
                    className="form-select h-54"
                    value={timezone}
                    onChange={(e) => setTimezone(e.target.value)}
                    style={{
                      backgroundColor: 'rgba(248, 249, 252, 1)',
                      borderColor: '#ced4da',
                      color: 'rgba(149, 149, 151, 1)',
                    }}
                  >
                    {timezoneOptions.map((option) => (
                      <option key={option.value} value={option.value} style={{ color: '#000' }}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div className='modal-footer modal-mes-footer d-flex align-items-center'>
            <button id="backGroupModalBtn" type='button' className='btn btn-outline-secondary me-3' data-bs-dismiss='modal'>
              <FormattedMessage id='CANCEL' />
            </button>
            <button id="saveGroupBtn" className='btn btn-primary but-darkblue' type='button' onClick={handleSubmit}>
              <FormattedMessage id='ADD_WIDGET' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Clock;
